var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoTime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 7V12L17 14.5L16 16L11.0141 12.9859V6.97653L13 7ZM6.31925 17.6808C7.9155 19.2457 9.80907 20.0282 12 20.0282C14.1909 20.0282 16.0767 19.2379 17.6573 17.6573C19.2379 16.0767 20.0282 14.1909 20.0282 12C20.0282 9.80907 19.2379 7.92333 17.6573 6.34272C16.0767 4.76212 14.1909 3.97183 12 3.97183C9.80907 3.97183 7.92333 4.76212 6.34272 6.34272C4.76212 7.92333 3.97183 9.80907 3.97183 12C3.97183 14.1909 4.7543 16.0845 6.31925 17.6808ZM4.9108 4.95775C6.88264 2.98591 9.24568 2 12 2C14.7543 2 17.1095 2.97808 19.0657 4.93427C21.0219 6.89046 22 9.24568 22 12C22 14.7543 21.0219 17.1095 19.0657 19.0657C17.1095 21.0219 14.7543 22 12 22C9.24568 22 6.89046 21.0219 4.93427 19.0657C2.97808 17.1095 2 14.7543 2 12C2 9.24568 2.97026 6.89829 4.9108 4.95775Z",
    fillOpacity: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoTime);
export default __webpack_public_path__ + "static/media/ico-time.c7446a34.svg";
export { ForwardRef as ReactComponent };